import { REDIRECT_URL_QUERY_PARAM } from '@constants/queryParams';
import {
  DUPLICATE_EVENT_INFO_ROUTE,
  OFFERS_ROUTE,
  PREVIEW_URL_PUBLISHED_ROUTE,
  PREVIEW_URL_UNPUBLISHED_ROUTE,
} from '@constants/routes';
import { Event, EventListItem } from '@domain/event';

export const createPathToEdit = ({ event, companyId }: { event: Event | EventListItem; companyId: string }): string => {
  return event.settings.isPublished
    ? OFFERS_ROUTE.replace(':companyId', companyId).replace(':clubSlug', event.club.slug).replace(':eventId', event.id)
    : '';
};

const createPreviewUrlWitoutQueryParams = ({
  event,
  locale,
  defaultChannel,
  isPublished,
}: {
  event: Event | EventListItem;
  locale: string;
  defaultChannel: string;
  isPublished: boolean;
}) => {
  if (isPublished)
    return PREVIEW_URL_PUBLISHED_ROUTE.replace(':lang', locale)
      .replace(':city-slug', event.club.city.slug)
      .replace(':event-slug', event.slug)
      .replace(':eventId', event.legacyId.toString())
      .replace(':channel-slug', defaultChannel);
  return PREVIEW_URL_UNPUBLISHED_ROUTE.replace(':lang', locale)
    .replace(':city-slug', event.club.city.slug)
    .replace(':event-slug', event.slug)
    .replace(':eventId', event.id)
    .replace(':channel-slug', defaultChannel);
};

export const createPreviewUrl = ({
  event,
  locale,
  defaultChannel,
  isWebView,
  isScheduledEvent,
}: {
  event: Event | EventListItem;
  locale: string;
  defaultChannel: string;
  isScheduledEvent?: boolean;
  isWebView?: boolean;
}): string => {
  if (!event) return '';
  if (!defaultChannel) return '';
  const isPublished = event.settings.isPublished && !event.settings.isHidden && !isScheduledEvent;
  const previewUrl = createPreviewUrlWitoutQueryParams({ defaultChannel, event, isPublished, locale });
  const queryParams = isWebView && !isPublished ? `?${REDIRECT_URL_QUERY_PARAM}=${window.location.href}` : '';
  return `${previewUrl}${queryParams}`;
};

export const createPathToDuplicate = ({ event, companyId }: { event: Event | EventListItem; companyId: string }) => {
  return event.settings.isPublished
    ? DUPLICATE_EVENT_INFO_ROUTE.replace(':companyId', companyId)
        .replace(':clubSlug', event.club.slug)
        .replace(':eventId', event.id)
    : undefined;
};
